import React, { useState, useEffect } from "react";
import {
    Paper,
    Typography,
    Box,
    Button,
    Container,
    Alert,
    Stack,
    TextField,
    MenuItem,
} from "@mui/material";
import DashboardLayout from "../Layout/DashboardLayout";

import excuseApi from "../../api/excuseApi";

const pages = [
    { label: "Trang chủ", value: "trangchu" },
    { label: "Lược sử", value: "luocsu" },
    { label: "Chiến Ký", value: "chienky" },
    { label: "Hồi Âm", value: "hoiam" },
    { label: "Giới Thiệu", value: "gioithieu" },
    { label: "Đăng Nhập - Đăng Ký", value: "dangnhap" },
];

export default function DashboardChangeBanner() {
    const [page, setPage] = useState("trangchu");
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [cacheKey, setCacheKey] = useState(Date.now());

    const currentBannerUrl = `${process.env.REACT_APP_STATIC_URL}/uploads/banner/banner_${page}.png?${cacheKey}`;

    // reset preview và lỗi khi đổi trang
    useEffect(() => {
        setPreviewUrl(null);
        setError("");
        setCacheKey(Date.now());    
    }, [page]);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;

        if (!selectedFile.name.toLowerCase().endsWith(".png")) {
            setError("Banner chỉ hỗ trợ ảnh PNG");
            setFile(null);
            setPreviewUrl(null);
            return;
        }

        setFile(selectedFile);
        setPreviewUrl(URL.createObjectURL(selectedFile));
        setError("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
        setError("");

        if (!file) {
            setError("Vui lòng chọn ảnh mới");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);
        formData.append("page", page);

        try {
            const res = await excuseApi({
                endpoint: '/upload-banner',
                method: 'POST',
                data: formData
            });

            setCacheKey(Date.now());
            setMessage("Cập nhật banner thành công!");
            setPreviewUrl(null);
            setFile(null);
        } catch (err) {
            setError(err?.response?.data?.error || "Có lỗi xảy ra");
        }
    };

    return (
        <DashboardLayout>
            <Container maxWidth="sm" sx={{ mt: 4 }}>
                <Paper sx={{ p: 4 }}>
                    <Typography variant="h5" gutterBottom>
                        🖼️ Chỉnh sửa Banner
                    </Typography>

                    <form onSubmit={handleSubmit}>
                        <Stack spacing={2} sx={{ mb: 2 }}>
                            {message && <Alert severity="success">{message}</Alert>}
                            {error && <Alert severity="error">{error}</Alert>}
                        </Stack>

                        <Box mb={2}>
                            <TextField
                                select
                                fullWidth
                                label="Chọn trang"
                                value={page}
                                onChange={(e) => setPage(e.target.value)}
                            >
                                {pages.map((p) => (
                                    <MenuItem key={p.value} value={p.value}>
                                        {p.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Box>

                        <Box mb={2}>
                            <img
                                src={previewUrl || currentBannerUrl}
                                alt="Current banner"
                                style={{ width: "100%", borderRadius: 8 }}
                            />
                        </Box>

                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mb: 1 }}
                        >
                            * Banner chỉ hỗ trợ ảnh PNG. Vui lòng không tải lên ảnh đuôi khác.
                        </Typography>

                        <Box mb={3}>
                            <Button variant="contained" component="label" fullWidth>
                                Chọn ảnh mới (.png)
                                <input
                                    hidden
                                    type="file"
                                    accept="image/png"
                                    onChange={handleFileChange}
                                />
                            </Button>
                        </Box>

                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            fullWidth
                        >
                            Xác nhận thay đổi
                        </Button>
                    </form>
                </Paper>
            </Container>
        </DashboardLayout>
    );
}
